// extracted by mini-css-extract-plugin
export default {"container":"io-z","bubbleNav":"jo-z","graphic":"ko-z","contact":"lo-z"};